import React, { useEffect, useState, memo } from "react";
import { Button, Col, Row, Form, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../../helper/api";
import AlertService from "../../../helper/alertService";

const Urls = ({ _selectedUrl, isShowUrlForm, setIsShowUrlForm, urlNames, urlTypes }) => {

	const [selectedUrl, setSelectedUrl] = useState(null);
	const navaigate = useNavigate();
	const { networkId } = useParams();
	const [values, setValues] = useState({
		networkPlatformId: +networkId,
		urlType: "",
		urlName: "",
		address: "",
		requestModel: "",
		responseModel: "",
		description: "",
	});

	useEffect(() => {
		if (_selectedUrl) {
			setSelectedUrl(_selectedUrl);
			setValues(Object.assign({}, values, _selectedUrl))
		}
	}, [_selectedUrl])

	const handleChange = (event, fieldName) => {
		setValues(value => ({ ...value, [fieldName]: event.target.value }))
	};

	const closeModal = () => {
		setIsShowUrlForm(false);
		setSelectedUrl(null);
		setValues({
			networkPlatformId: +networkId,
			urlType: "",
			urlName: "",
			address: "",
			requestModel: "",
			responseModel: "",
			description: "",
		})
	}

	const onChange = (event) => {
		setValues(values => ({
			...values,
			[event.target.name]: event.target.value,
		}));
	};

	const onSubmit = (event) => {
		event && event.preventDefault();
		(selectedUrl ? ApiService.updateUrl(values) : ApiService.createUrl(values)).then(response => {
			AlertService.alert("success", `Url ${selectedUrl ? 'Updated' : 'Created'} successfully`);
			navaigate(`/network-platform-view/${networkId}`);
			setValues({
				networkPlatformId: +networkId,
				urlType: "",
				urlName: "",
				address: "",
				requestModel: "",
				responseModel: "",
				description: "",
			})

		}).catch(error => {
			AlertService.alert("error", error);
		}).finally(() => {
			closeModal(true)
		});
	}

	return <div>
		<Modal
			show={selectedUrl || isShowUrlForm}
			onHide={() => {
				closeModal();
			}}
			size="lg"
			scrollable
		>
			<Modal.Header closeButton>
				<Modal.Title>{!selectedUrl ? "Create Url" : "Upadate Url"}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={onSubmit}>
						<Row>
							<Col md={6}>
								<Form.Group className="mb-3" >
									<Form.Label>Url Type</Form.Label>
									{
										urlTypes && urlTypes.length ?
											<Form.Select onChange={(event) => handleChange(event, "urlType")}>
												<option value={null} hidden>{values && values.urlType ? values.urlType : "Select Url Type"}</option>
												{urlTypes
													.map((key, index) => (key !== values.urlType &&
														<option key={index} value={key}>{key}</option>
													))}
											</Form.Select>
											: null
									}
								</Form.Group>
							</Col>
							<Col md={6}>
								<Form.Group className="mb-3">
									<Form.Label>Url Name</Form.Label>
									{
										urlNames && urlNames.length ?
											<Form.Select onChange={(event) => handleChange(event, "urlName")} >
												<option value={null} hidden>{values && values.urlName ? values.urlName : "Select Url Name"}</option>
												{urlNames
													.map((key, index) => (key !== values.urlName &&
														<option key={index} value={key}>{key}</option>
													))}
											</Form.Select>
											: null
									}
								</Form.Group>
							</Col>
						</Row>
					<Form.Group className="mb-3">
						<Form.Label>Address</Form.Label>
						<Form.Control
							type="text"
							value={values?.address || ""}
							onChange={onChange}
							name="address"
						/>
					</Form.Group>
					<div className="form-group">
						<label htmlFor="description">Description</label>
						<textarea
							id="description"
							name="description"
							className="form-control"
							rows={values?.description && values?.description.length ? values.description.split('\n').length : 1}
							value={values?.description || ""}
							onChange={onChange}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="description">Request Model</label>
						<textarea
							id="requestModel"
							name="requestModel"
							className="form-control"
							rows={values?.requestModel && values?.requestModel.length ? values.requestModel.split('\n').length : 1}
							value={values?.requestModel || ""}
							onChange={onChange}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="responseModel">Response Model</label>
						<textarea
							id="responseModel"
							name="responseModel"
							className="form-control"
							rows={values?.responseModel && values?.responseModel.length ? values.responseModel.split('\n').length : 1}
							value={values?.responseModel || ""}
							onChange={onChange}
						/>
					</div>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={closeModal}>
					Close
				</Button>
				<Button
					variant="primary"
					type="submit"
					onClick={onSubmit}
					disabled={!values.urlName || !values.urlType}
				>
					Save
				</Button>
			</Modal.Footer>
		</Modal>
	</div>
}

export default memo(Urls);
